import * as z from "zod";

export const deleteCalendarEntry = {
  name: "deleteCalendarEntry" as const,
  input: z.object({ id: z.string() }),
  output: z.null(),
};
